import { Blocks } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Card, CardContent, CardHeader } from '~/components/ui/card';
import type { CategoryCoverageRow } from '~/features/catalog-operations/types/catalog-operations.types';

import { CoverageBar } from '../coverage-bar';

interface Props {
  rows: CategoryCoverageRow[];
}

export function CategoryCoverageList({ rows }: Props) {
  const { t } = useTranslation('catalog-operations');
  return (
    <Card data-testid="batch-detail-category-coverage-card">
      <CardHeader className="flex flex-row items-center gap-4 p-6">
        <div className="bg-primary/10 text-primary flex h-11 w-11 shrink-0 items-center justify-center rounded-lg">
          <Blocks className="h-5 w-5" aria-hidden="true" />
        </div>
        <div className="space-y-0.5">
          <h2 data-testid="batch-detail-category-coverage-title" className="text-xl font-medium">
            {t('categoryCoverage.title')}
          </h2>
          <p className="text-muted-foreground text-sm font-light">
            {t('categoryCoverage.subtitle')}
          </p>
        </div>
      </CardHeader>

      <CardContent className="bg-primary/4 mr-6 mb-6 ml-6 max-h-65 overflow-y-auto rounded-xl p-3">
        <ul data-testid="batch-detail-category-coverage-list">
          {rows.map((row) => (
            <li
              key={row.label}
              data-testid={`batch-detail-category-coverage-item-${row.label}`}
              className="grid grid-cols-[minmax(0,1fr)_minmax(0,1.6fr)_auto] items-center gap-4 px-3 py-3"
            >
              <div className="flex flex-wrap items-center">
                <span className="text-sm capitalize">{(row.label || '').replaceAll('-', ' ')}</span>
              </div>
              <CoverageBar percent={row.percent} />
              <span
                data-testid={`batch-detail-category-coverage-item-value-${row.label}`}
                className="w-12 text-right text-sm font-bold tabular-nums"
              >
                {row.percent}%
              </span>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
}
